export const defaultStateValues = {
  highlightedIndex: -1,
  isOpen: false,
  selectedItem: null as unknown,
  inputValue: '',
}
